// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3B3oq","col":"Table_col__2NXrm","fulfillmentStatus":"Table_fulfillmentStatus__2FI6R","emailCol":"Table_emailCol__1Fu07"};